import { Storage } from "@ionic/storage-angular";
import { Injectable, EventEmitter } from "@angular/core";
import { AppService } from "../app.service";
import { Subject, Observable } from "rxjs";
import { Global } from "src/global";

export interface PeopleFilterProperties {
  filter: string;
  sort: string;
  skip: number;
  take: number;
  callingFilter: string;
  User_GUID: string;
}

@Injectable({
  providedIn: "root",
})
export class PeopleService {
  peopleSearchText: string = "";
  allpeopleList: any = [];
  peopleList: any = [];
  peopleSelected: any;
  peopleSelectedList = [];
  peopleSelectedListEmitter: EventEmitter<any> = new EventEmitter();
  peopleFilterProperties: PeopleFilterProperties;
  peopleFilterPropertiesEmitter: EventEmitter<PeopleFilterProperties> =
    new EventEmitter();
  navigatedFromLink: string;
  navigatedFromLinkButtonLabel: string;
  navigatedFromParams: any;

  constructor(
    private storage: Storage,
    public globals: Global,
    private appservice: AppService
  ) {
    this.peopleFilterProperties = {
      filter: "AllPeople",
      sort: "Created",
      skip: 0,
      take: 20,
      callingFilter: "",
      User_GUID: "",
    };
  }

  refresh() {
    this.peopleFilterPropertiesEmitter.emit(this.peopleFilterProperties);
  }

  setPeopleFilterProperties(peopleFilterProperties: PeopleFilterProperties) {
    this.peopleFilterProperties = peopleFilterProperties;
  }

  clearPeopleFilter() {
    this.peopleFilterProperties = {
      filter: "AllPeople",
      sort: "Created",
      skip: 0,
      take: 20,
      callingFilter: "",
      User_GUID: "",
    };
  }

  clearService() {
    this.clearPeopleFilter();
    this.clearPeopleSelectedList();
  }

  pushToPeopleSelectedList(people: any) {
    this.peopleSelectedList.push(people);
  }

  removeFromPeopleSelectedList(people: any) {
    this.peopleSelectedList.splice(people);
  }

  clearPeopleSelectedList() {
    this.peopleSelectedList = [];
  }

  emitPeopleSelectedList() {
    this.peopleSelectedListEmitter.emit(this.peopleSelectedList);
  }

  setNavigatedFromLink(navigatedFromLink: string) {
    this.navigatedFromLink = navigatedFromLink;
  }

  setNavigatedFromParams(navigatedFromParams: any) {
    this.navigatedFromParams = navigatedFromParams;
  }

  getNavigatedFromLink() {
    return this.navigatedFromLink;
  }

  getNavigatedFromParams() {
    return this.navigatedFromParams;
  }

  setNavigatedFromLinkButtonLabel(navigatedFromLinkButtonLabel: string) {
    this.navigatedFromLinkButtonLabel = navigatedFromLinkButtonLabel;
  }

  setSelectedPeople(people: any) {
    this.peopleSelected = people;
  }

  getSelectedpeople() {
    return this.peopleSelected;
  }

  resetService() {
    this.navigatedFromLink = "";
  }

  GetDepartmentList(): Observable<any> {
    var subject = new Subject<any>();
    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);

    this.appservice.GetDepartmentList(formData).subscribe((res) => {
      try {
        subject.next(JSON.parse(res.toString()));
      } catch (e) {}
    });

    return subject.asObservable();
  }

  GetPeopleList(): Observable<any> {
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("search", this.peopleSearchText);
    formData.append("filter", this.peopleFilterProperties.filter);
    formData.append("sort", this.peopleFilterProperties.sort);
    formData.append("take", "" + this.peopleFilterProperties.take);
    formData.append("skip", "" + this.peopleFilterProperties.skip);
    formData.append(
      "callingFilter",
      "" + this.peopleFilterProperties.callingFilter
    );
    formData.append("User_GUID", "" + this.peopleFilterProperties.User_GUID);

    this.appservice.GetPeopleList(formData).subscribe((res) => {
      try {
        subject.next(JSON.parse(res.toString()));
      } catch (e) {}
    });

    return subject.asObservable();
  }
}
